
import {Cuentas} from "../../services/cuentas.js";
export default {
  namespaced: true,
  state: {
    usuario_caja: [],
    email: "",
    loading: false,
    busqueda: false,
    usuario: [],
    clienteID: null,
    loadingSearch: false,
  },
  mutations: {
    setUsuarioCaja(state, value) {
      state.usuario_caja = value;
      },
      setEmail(state, value) {
        state.email = value;
    },
      setLoadingSearch(state, value) {
        state.loadingSearch = value;
    },
      setBusqueda(state, value) {
        state.busqueda = value;
    },
      setUsuario(state, value) {
        state.usuario = value;
    },
      
      setClienteID(state, value) {
        state.clienteID = value;
    },
  },
  actions: {

    setUsuarioCaja({ commit }, value) {
      commit("setUsuarioCaja", value);
      },
      setEmail({ commit }, value) {
        commit("setEmail", value);
    },
      
    setBusqueda({ commit }, value) {
      commit("setBusqueda", value);
    },
      
    setLoadingSearch({ commit }, value) {
      commit("setLoadingSearch", value);
    },

    setUsuario({ commit }, value) {
      commit("setUsuario", value);
    },

    setClienteID({ commit }, value) {
      commit("setClienteID", value);
    },
    
    async getUsuarioCaja({ commit, state, rootState },cliente_id) {   
      commit("setLoadingSearch", true);
      const params = {
         email: state.email,
        cliente_id: cliente_id || rootState.cliente_id || state.clienteID ,
      };
      await Cuentas.getUsuarioCaja(params)
        .then((response) => {
          if (response?.data?.status) {
            commit("setUsuarioCaja", response?.data?.data)
          } else {
            commit("setUsuarioCaja", [])
          }
          
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          commit("setLoadingSearch", false);
        });
    },
    
  },
  getters: {
    usuario_caja: (state) => state.usuario_caja,
    usuario: (state) => state.usuario,
    email: (state) => state.email,
    loadingSearch: (state) => state.loadingSearch,
    busqueda: (state) => state.busqueda,
    clienteID: (state) => state.clienteID,
  },
  modules: {},
};
